import { Text, TouchableOpacity, View } from 'react-native'
import { Ionicons } from '@expo/vector-icons'

// styles
import {
  colorPalette,
  fontPalette,
  globalStyles
} from '../../../static/styles/global'

interface twoColumnDisplayProps {
  firstTitle: string
  firstDescription: string
  firstVisibility?: boolean
  secondTitle: string
  secondDescription: string
  secondVisibility?: boolean
  gap?: number
}

const TwoColumnDisplay = ({
  firstTitle,
  firstDescription,
  firstVisibility,
  secondTitle,
  secondDescription,
  secondVisibility,
  gap = 0
}: twoColumnDisplayProps): JSX.Element => {
  return (
    <View
      style={[
        globalStyles.hDirection,
        globalStyles.hBetweenItems,
        { marginBottom: gap }
      ]}
    >
      <View style={[globalStyles.colHalf, globalStyles.colLeft]}>
        <Text
          style={[
            globalStyles.text,
            globalStyles.primaryTextColor,
            globalStyles.fwSemiBold,
            globalStyles.mb1
          ]}
        >
          {firstTitle}
        </Text>
        <View style={[globalStyles.ml2, globalStyles.hDirection]}>
          <Text style={[globalStyles.text, globalStyles.grayTextColor]}>
            {firstDescription}
          </Text>
          {firstVisibility && (
            <TouchableOpacity
              onPress={() => {}}
              style={[
                globalStyles.relativePosition,
                globalStyles.tn2,
                globalStyles.ml2
              ]}
            >
              <Ionicons
                name="eye-outline"
                size={24}
                color={colorPalette.secondary}
              />
            </TouchableOpacity>
          )}
        </View>
      </View>
      <View style={[globalStyles.colHalf, globalStyles.colRight]}>
        <Text
          style={[
            globalStyles.text,
            globalStyles.primaryTextColor,
            globalStyles.fwSemiBold,
            globalStyles.mb1
          ]}
        >
          {secondTitle}
        </Text>
        <View style={[globalStyles.ml2, globalStyles.hDirection]}>
          <Text style={[globalStyles.text, globalStyles.grayTextColor]}>
            {secondDescription}
          </Text>
          {secondVisibility && (
            <TouchableOpacity
              onPress={() => {}}
              style={[
                globalStyles.relativePosition,
                globalStyles.tn2,
                globalStyles.ml2
              ]}
            >
              <Ionicons
                name="eye-outline"
                size={24}
                color={colorPalette.secondary}
              />
            </TouchableOpacity>
          )}
        </View>
      </View>
    </View>
  )
}

export default TwoColumnDisplay
